import { EMPTY_FIELD } from 'constants/emptyField';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { FunctionField, NumberField, TextField } from 'shared/react-admin/Fields';
import { CommissionActiveStep } from 'types/embedded/commission';

export const CommissionsTabsActiveStep: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <CardTable>
      <TableRowWrapper label="Метод">
        <TextField emptyText={EMPTY_FIELD} label="Метод" source="method.name" />
      </TableRowWrapper>
      <TableRowWrapper label="Номер активной ступени">
        <NumberField
          emptyText={EMPTY_FIELD}
          label="Номер ступени"
          source="currentStep.stepNumber"
        />
      </TableRowWrapper>
      <TableRowWrapper label="Порог от-до">
        <FunctionField
          emptyText={EMPTY_FIELD}
          label="Порог от-до"
          render={(record: CommissionActiveStep) =>
            `${record?.currentStep.thresholdFrom || 0} - ${record?.currentStep.thresholdTo || '∞'}`
          }
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.percent')}>
        <FunctionField
          label="Процент"
          render={(record: CommissionActiveStep) => {
            if (!record?.currentStep.commissionRate.percent) {
              return EMPTY_FIELD;
            }
            return `${record?.currentStep.commissionRate.percent}%`;
          }}
          source="commissionRate.percent"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.fixed')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.fixed')}
          source="currentStep.commissionRate.fix"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.max')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.max')}
          source="currentStep.commissionRate.max"
        />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.min')}>
        <NumberField
          emptyText={EMPTY_FIELD}
          label={translate('app.commissions.min')}
          source="currentStep.commissionRate.min"
        />
      </TableRowWrapper>
    </CardTable>
  );
};
